export default "__VITE_ASSET__BeD0SBg2__ 720w";